import { render, staticRenderFns } from "./CollectionsDisplay.vue?vue&type=template&id=b85b6672&scoped=true"
import script from "./CollectionsDisplay.vue?vue&type=script&lang=js"
export * from "./CollectionsDisplay.vue?vue&type=script&lang=js"
import style0 from "./CollectionsDisplay.vue?vue&type=style&index=0&id=b85b6672&prod&scoped=true&lang=css"
import style1 from "./CollectionsDisplay.vue?vue&type=style&index=1&id=b85b6672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85b6672",
  null
  
)

export default component.exports